export default "__VITE_ASSET__WY0KGohP__"